import api from "./api";
//import categoryApi from "@/views/moving_function/components/mall_category_select2/api";
import { GetAkData } from "@/views/moving_function/views/shipping_preview_list/bos_config";
import newSkuUtil from "@/views/moving_function/utils/sku/index";
import imgUtil from "@/views/moving_function/utils/img";
import { COU_Sleep } from "@/utils/co_utils";
import store from "@/store";
import zfbApi from "@/api/zfb/auth";

async function getUserInfo(token) {
  const { result } = await zfbApi.GetCurrentUserData(token);
  return result;
}
// 如果有改变原图，则需要上传到百度云再铺货
async function getFinalImageUrl(list) {
  for (let item of list) {
    if (item.isUpdate) {
      let file = await imgUtil.Base64ToFile(item.img);
      // 如果没有file 说明转换的时候出了问题, 那就跳过这张图片
      if (!file) {
        item.isError = true;
        continue;
      }
      item.img = await api.UploadImage2(file);
      item.isUpdate = false;
    }
  }
  return list.filter((item) => !item.isError);
}

// 整理铺货需要的商品详情数据
async function getFormatGoodsData(goods) {
  if (goods.mainImages?.length)
    goods.mainImages = await getFinalImageUrl(goods.mainImages);
  if (goods.detailImages?.length)
    goods.detailImages = await getFinalImageUrl(goods.detailImages);
  if (goods.skuInfo?.[0]?.images?.length)
    goods.skuInfo[0].images = await getFinalImageUrl(goods.skuInfo[0].images);
  const newGoods = {
    ItemId: goods.id,
    PlatformType: goods.platformType,
    Title: goods.title.trim(),
    CatIds: goods.category?.length ? goods.category.split(",") : [],
    MainPicList: goods.mainImages.map((item) => item.img),
    DescPicList: goods.detailImages.map((item) => item.img),
    WhiteBackGroundPic: "",
    BrandId: goods.brandId,
    BrandName: goods.brandName,
    Desc: "",
    SpecPicList: null,
    OriginCatIds: goods.OriginCatIds,
    OriginCatNames: goods.OriginCatNames,
  };
  // 整理sku数据
  newSkuUtil.FormatSubmitSkuData({ submitData: newGoods, item: goods });
  newGoods.PropFormat = null;
  console.log("最终......", newGoods);
  return newGoods;
}

// 删除待铺货的商品
function DeleteGoods(This, goodsId) {
  goodsId = typeof goodsId === "object" ? goodsId : [goodsId];
  This.list = This.list.filter((item) => !goodsId.includes(item.id));
  This.needUpdateList = This.needUpdateList.filter(
    (item) => !goodsId.includes(item.id)
  );
  This.needUpdateList.map((item) => {
    let index = This.list.findIndex((i) => i.id === item.id);
    item.index = ++index;
    if (item.errorMsg?.split("，")?.length > 1)
      item.errorMsg = `第【${item.index}】个商品，${
        item.errorMsg.split("，")[1]
      }`;
  });
  This.$message.success("删除商品成功");
}

// 点击【开始铺货】时执行
async function StartMove(This) {
  // --------- 上传到百度云前验证开始 ---------
  const result = await GetAkData();
  if (!result?.success) {
    This.$message.warning(result?.msg);
    return (This.loading = false);
  }
  // --------- 上传到百度云前验证结束 ---------
  This.isShowLogModal = true;
  This.$nextTick(async () => {
    This.$refs.logModal.clear();
    This.$refs.logModal.addLog(
      `正在进行【${This.list.length}】个商品铺货中，请耐心等待...`
    );
    await moving(This);
    This.loading = false;
  });
}

// 铺货中
async function moving(This) {
  for (let i = 0; i < This.list.length; i++) {
    await COU_Sleep(500);
    const item = This.list[i];
    const itemFormat = await getFormatGoodsData(item);
    await api.CustomMove({
      logId: item.logId,
      itemFormat: JSON.stringify(itemFormat),
    });
    This.$refs.logModal.addLog(
      `序号：${i + 1}，商品ID：【${item.id}】，正在后台进行中`
    );
  }
  This.$emit("finish");
  This.$refs.logModal.addLog(
    `已经执行完毕，共铺货【${This.list.length}】个商品，铺货状态会有延迟${
      !This.isOutUse ? "，可前往【上货列表】查看铺货结果" : ""
    }`
  );
  This.list = [];
}

// 获取第一级分类
async function GetFirstCategoryList(This) {
  // const { list } = await categoryApi.GetGoodsCategoryList()
  const { list } = await store.dispatch("mall_group/getMallCategory");
  This.categoryList = list;
}

// 获取标题的长度 (中文是2个字符，字母和数字是1个字符)
function GetTitleLength(title) {
  let len = 0;
  for (let i = 0; i < title.length; i++) {
    len += title.charCodeAt(i) > 255 ? 2 : 1;
  }
  return len;
}

// 验证商品的各类图片是否存在
function ValidateImage(list, title, msg) {
  let str = msg;
  if (list?.length) {
    for (let j in list) {
      const obj = list[j] || {};
      if (!obj.img || (!obj.width && !obj.height)) {
        str += ` 第${+j + 1}个${title}没有获取到图片，请手动上传图片、`;
      } else if (obj.img && obj.width === 1 && obj.height === 1) {
        str += ` ${title}里没有获取到图片，需要手动上传图片、`;
        break;
      }
    }
  }
  return str;
}

// 滚动到指定位置
function ScrollIntoView(tragetElem, nowElem, length) {
  const topValue = length ? 98 : 82;
  const tragetElemPostition = tragetElem.offsetTop - topValue;
  // 当前滚动高度
  let scrollTop = nowElem.scrollTop;
  // 滚动step方法
  const step = function () {
    // 距离目标滚动距离
    let distance = tragetElemPostition - scrollTop;
    // 目标需要滚动的距离，也就是只走全部距离的五分之一
    scrollTop = scrollTop + distance / 5;
    if (Math.abs(distance) < 1) nowElem.scrollTo(0, tragetElemPostition);
    else {
      nowElem.scrollTo(0, scrollTop);
      setTimeout(step, 5);
    }
  };
  step();
}

export default {
  StartMove,
  DeleteGoods,
  GetFirstCategoryList,
  GetTitleLength,
  getUserInfo,
  ValidateImage,
  ScrollIntoView,
};
